<template>
    <div
        style="
        background: #F5F5F5;"
    >
        <top></top>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
         <div v-html="xml">

         </div>

        </div>



        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";

export default {
    data() {
        return {
            url: [{ name: "招聘信息", url: "/recrutment" }],
            xml:''

        };
    },
    created() {
      this.xml =  this.$route.query.content
      console.log(this.xml);
    },
    methods: {




    },
    components: {
        top,
        breadcrumb,
        bottom
    },

};
</script>
<style lang="less" scoped>
.container{
    height: 500px;
}

</style>



// WEBPACK FOOTER //
// src/views/index/recrutmentDetail.vue